import { useState } from "react";
import { DatalistCard } from "./Datalist.style";
import HighlightList from "../common/HighlightList";
import GroupView from '../groups/GroupView'

const DatalistItem = ({ scrollId, ...props }) => {
  const [edit, setEdit] = useState(false);
  const [toggles, setToggles] = useState({});
  const onClose = () => setEdit(false)
  const onEdit = () => setEdit(true)
  const onToggle = key => setToggles({ ...toggles, [key]: !toggles?.[key] })
  const cardProps = { onClose, onEdit, onToggle, toggles, ...props }

  return (
    <HighlightList scrollId={scrollId} id={props.id}>
      <DatalistCard>
        {
          edit
            ? <GroupView {...cardProps} editMode />
            : <GroupView {...cardProps} />
        }
      </DatalistCard>
    </HighlightList>
  );
};

export default DatalistItem;
